<template>
    <span>
        <!-- ****************    Menú lateral para pantallas medianas y grandes:     ***************************-->
        <v-navigation-drawer
            class="grey lighten-3"
            clipped
            v-model="drawer"
            permanent
            app
            hide-overlay
            stateless
        >
            <v-container>
                <v-layout align-center justify-center>
                    <v-flex xs12>
                        <div class="tw-green headline font-weight-medium">{{ $t('lbl-login') }}</div>
                    </v-flex>
                </v-layout>

                <v-layout row justify-space-around>
                    <v-flex xs12>
                        <v-form ref="form" v-model="valid" @submit.prevent>
                            <v-container>
                                <v-layout row justify-space-around>
                                    <v-flex xs10>
                                        <v-text-field
                                            color="teal darken-1"
                                            prepend-icon="mdi-account"
                                            name="email"
                                            :label="$t('lbl-email')"
                                            type="email"
                                            v-model="email"
                                            :rules="emailRules"
                                            required
                                            align-self-center
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row justify-space-around>
                                    <v-flex xs10>
                                        <v-text-field
                                            color="teal darken-1"
                                            prepend-icon="mdi-lock"
                                            name="password"
                                            :label="$t('lbl-password')"
                                            id="password"
                                            type="password"
                                            required
                                            v-model="password"
                                            :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
                                            @click:append="() => (e1 = !e1)"
                                            :type="e1 ? 'password' : 'text'"
                                            :rules="passwordRules"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row justify-space-around>
                                    <v-btn
                                        type="submit"
                                        @submit.prevent="checkLogin"
                                        @click="onSubmit"
                                        :class="{'teal darken-1 white--text': valid, disabled: !valid}"
                                    >{{ $t('btn-ok') }}</v-btn>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-navigation-drawer>
    </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    data() {
        return {
            drawer: true,
            valid: false,
            e1: true,
            password: '',
            passwordRules: [(v) => !!v || 'Introduzca la contraseña'],
            email: '',
            emailRules: [
                (v) => !!v || 'Introduzca su correo electrónico',
                (v) =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido',
            ],
        };
    },

    methods: {
        onSubmit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('login', {
                    email: this.email,
                    password: this.password,
                });
            }
        },
        clear() {
            this.$refs.form.reset();
        },
    },
    computed: {
        failedLogin: {
            get() {
                return this.$store.getters.failedLogin;
            },
            set(failedLogin) {
                this.$store.dispatch('updateFailedLogin', failedLogin);
            },
        },
        inactiveUser: {
            get() {
                return this.$store.getters.inactiveUser;
            },
            set(inactiveUser) {
                this.$store.dispatch('updateInactiveUser', inactiveUser);
            },
        },
        waitCursor() {
            return this.$store.getters.waitCursor;
        },
    },
};
</script>



<style scoped>
.tw-green {
    color: #00897b;
    /* teal darken-1 */
}

.tw-gray {
    color: #757575;
    /* grey darken-1 */
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>